import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'cpf'
})
export class CPFPipe implements PipeTransform {
  transform(value: string, ...args: any[]): any {
    if (value != null && value.length <= 14) {
      return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4")
    }
  }
}
